export const blockIconsHardwareKeyboardArrowDown = (
	<span className='material-symbols-outlined'>keyboard_arrow_down</span>
);
